import { FC } from 'react';
import { CaretDownIcon } from 'assets/icons';
import LineItemsV2 from '../LineItemsV2';
import { InvoiceByIdV2 } from '../../invoices.model';

interface InvoiceLineItemsViewSectionProps {
  invoice: InvoiceByIdV2;
  onInvoiceDetailsClick: () => void;
}

const InvoiceLineItemsViewSection: FC<InvoiceLineItemsViewSectionProps> = ({ invoice, onInvoiceDetailsClick }) => {
  return (
    <div className="rounded-md bg-white shadow-section">
      <LineItemsV2 invoice={invoice} borderStyle={invoice.isPaid ? 'rounded-b-md' : ''} />
      <div
        id="view-detailed-invoice-click"
        onClick={onInvoiceDetailsClick}
        className="flex cursor-pointer items-center justify-between py-4 px-5">
        <div className="text-sbase font-semibold text-secondary">View detailed invoice</div>
        <div>
          <CaretDownIcon className="-rotate-90" />
        </div>
      </div>
    </div>
  );
};

export default InvoiceLineItemsViewSection;
